<template>
  <section class="cs-loader" :class="{ 'cs-loader_hidden': hidden }">
    <div class="cs-loader__wrap" :class="{ 'cs-loader__animation-end': finish }">
      <div class="cs-loader__loader">
        <img class="cs-loader__breathe" src="@/assets/animations/breathe.gif" alt="" />
        <img class="cs-loader__spinner" src="@/assets/animations/spinner.gif" alt="" />
        <img class="cs-loader__icon" :src="icon" @error="error" alt="" />
      </div>
      <div class="cs-loader__title">{{ title }}</div>
      <div class="cs-loader__description ml-5 mr-5">
        {{ description }}
      </div>
      <div class="cs-loader__cancel ml-5 mr-5 mt-3">
        <custom-button v-if="buttonText" @handle-click="handleClick()" :name="buttonText"
          class="w-100 cs-loader__cancel__btn" />
      </div>
    </div>
  </section>
</template>

<script>
import customButton from "@/views/customButton.vue";
export default {
  components: { customButton },
  props: {
    title: {
      type: String,
      default: "Title",
    },
    error: Function,
    icon: {
      type: String,
    },
    description: {
      type: String,
      default: "Desc",
    },
    buttonText: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      hidden: true,
      finish: false,
    };
  },
  methods: {
    start() {
      this.hidden = false;
      this.finish = false;
    },
    end() {
      this.finish = true;
      setTimeout(() => {
        this.hidden = true;
      }, 320);
    },
    handleClick() {
      this.$emit("hide", true);
      this.hide();
    },
    hide() {
      this.hidden = true;
      this.finish = true;
    },
  },
};
</script>

<style lang="scss" scoped>
$default-margin-left: -25px;
$default-container-width: 420px;

@keyframes loader {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes opacity {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes end {
  0% {
    width: 66px;
    height: 66px;
  }

  100% {
    width: 17px;
    height: 17px;
  }
}

.cs-loader {
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  width: 100%;
  height: 100%;
  /* left: 0; */
  background-color: #FFF;
  z-index: 9;
  display: flex;
  align-items: center;
  justify-content: center;

  // @media (max-width: 1024px) {
  //   margin: auto;
  //   width: $default-container-width;
  //   left: unset;
  //   margin-left: $default-margin-left;
  //   /* Adjust the width for tablets */
  // }

  // @media (max-width: 768px) {
  //   width: $default-container-width;
  //   left: unset;
  //   /* Adjust the width for standard mobile devices */
  //   margin: auto;
  //   margin-left: $default-margin-left;
  // }

  // @media (max-width: 480px) {
  //   width: 100%;
  //   /* Adjust the width for small mobile devices */
  //   height: 100vh;
  //   left: 0;
  //   margin: auto;
  //   margin-left: $default-margin-left;
  // }
  &_hidden {
    display: none;
  }

  &__loader {
  width: 300px;
  height: 300px;
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);

  @media (max-width: 1024px) {
    left: 50%;
  }

  @media (max-width: 768px) {
    left: 50%;
  }
}

  &__icon {
    position: absolute;
    left: 0;
    top: 0;
    padding: 40%;
    z-index: 9999999;
    width: 300px;
    height: 300px;
  }

  &__spinner {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }

  &__breathe {
    position: absolute;
    height: 100%;
    width: 100%;
    padding: 15%;
    left: 0;
    top: 0;
  }

  &__title {
    font-size: 18px;
    font-weight: 700;
    line-height: 23px;
    letter-spacing: 0em;
    text-align: center;
    margin-top: 200px;
  }

  &__description {
    font-size: 16px;
    font-weight: 500;
    line-height: 21px;
    letter-spacing: 0em;
    text-align: center;
    margin-top: 5px;
  }

  &__cancel__btn {
    background: transparent;
    font-size: 16px;
    color: rgba(87, 87, 245, 1);
    outline: none;
    border: none;
    font-weight: 500;

    &:hover {
      color: rgba(87, 87, 245, 1);
      background: transparent;
      text-decoration: underline rgba(87, 87, 245, 1);
    }

    &:active {
      color: rgba(87, 87, 245, 1);
      background: transparent;
      text-decoration: underline rgba(87, 87, 245, 1);
    }

    &:focus {
      color: rgba(87, 87, 245, 1);
      background: transparent;
      text-decoration: underline rgba(87, 87, 245, 1);
    }
  }

  &__box {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    animation: loader 1.6s cubic-bezier(0.6, 0, 0.4, 1) infinite, opacity 1.6s;
  }

  &__animation-end {
    animation: end 0.32s ease-in;
  }

  &__item {
    position: absolute;
    width: 17px;
    height: 17px;
    border-radius: 50%;

    &_1 {
      bottom: 0;
      left: 0;
      background-color: $black200;
    }

    &_2 {
      bottom: 0;
      right: 0;
      background-color: $black300;
    }

    &_3 {
      top: 0;
      right: 0;
      background-color: $black400;
    }

    &_4 {
      top: 0;
      left: 0;
      background-color: $black600;
    }
  }
}
</style>
